(function () {
    /**
     * add style top overlay navbar and content class in main, they look for the height header
     */
    function getCookie(name) {
        var match = document.cookie.match(RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
        return match ? match[1] : null;
    }

    /**
     * Hide the notice bar if the cookie hide_notice is true
     */
    const checkCookieHasNoticeHidden = () => {
        var hide_notice = getCookie("hide_notice");

        if (hide_notice == null) {
            const el = document.getElementById('site-notice');
            if (el === null) {
                return;
            }
            el.style.display = "block";
        }
    };

    /**
     * Close the header-notice when the close button is clicked
     */
    const onClick = event => {
        const notice_btn = event.target.closest('button#site-notice__btn');
        if (notice_btn === null) {
            return;
        }

        const notice_parent = notice_btn.closest('div#site-notice');

        notice_parent.style.display = "none";

        document.cookie = "hide_notice=1; Secure";

        event.preventDefault();
    }

    document.addEventListener('click', onClick);

    document.addEventListener('load', () => {
        console.log("load event");
        checkCookieHasNoticeHidden();
    });

    document.addEventListener('DOMContentLoaded', () => {
        checkCookieHasNoticeHidden();
    });
}())



// WEBPACK FOOTER //
// ./scripts/custom/header.js